var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouseSearchingBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.74,180.31c-9.62-23.44-24.36-45.18-43.3-61.66C372.22,99.33,337.17,84.43,307.54,95c-30.67,10.9-51.18,37-73.92,58.28-8,7.46-16.72,14.53-27.09,18.69-47.45,19-79.68-6.92-121.76,22.48S39.1,282.61,66.86,319.79s94,32,144.15,32,42.08,35.45,129.83,36.31c89.73.89,118.05-94.3,108.35-165.54A173.18,173.18,0,0,0,437.74,180.31Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.74,180.31c-9.62-23.44-24.36-45.18-43.3-61.66C372.22,99.33,337.17,84.43,307.54,95c-30.67,10.9-51.18,37-73.92,58.28-8,7.46-16.72,14.53-27.09,18.69-47.45,19-79.68-6.92-121.76,22.48S39.1,282.61,66.86,319.79s94,32,144.15,32,42.08,35.45,129.83,36.31c89.73.89,118.05-94.3,108.35-165.54A173.18,173.18,0,0,0,437.74,180.31Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238,121c-5.8-3.17-8.44-.53-10.55-3.17s5.8-9.5-10-16.36c0,0-1.05-14.77-22.69-15.3S178.91,101,173.1,104.65s-7.39-2.11-13.19,1.58-3.17,11.08-7.92,12.14-11.08-4.75-16.89-1.06-5.8,6.87-8.44,6.87-7.92-2.12-11.08,0-6.86,4.75-6.86,4.75H242.24S243.82,124.18,238,121Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,121c-5.8-3.17-8.44-.53-10.55-3.17s5.8-9.5-10-16.36c0,0-1.05-14.77-22.69-15.3S178.91,101,173.1,104.65s-7.39-2.11-13.19,1.58-3.17,11.08-7.92,12.14-11.08-4.75-16.89-1.06-5.8,6.87-8.44,6.87-7.92-2.12-11.08,0-6.86,4.75-6.86,4.75H242.24S243.82,124.18,238,121Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.61,143.31c-3.73-2-5.43-.34-6.78-2s3.73-6.11-6.44-10.51c0,0-.68-9.5-14.58-9.84s-10.17,9.5-13.9,11.87-4.75-1.36-8.48,1-2,7.12-5.09,7.8-7.12-3.06-10.84-.68-3.73,4.4-5.43,4.4-5.09-1.35-7.12,0-4.41,3.06-4.41,3.06h85.78S351.34,145.34,347.61,143.31Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--House--inject-61"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.09,
    y: 240.42,
    width: 272.47,
    height: 85.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.56,326.9H112.09a.5.5,0,0,1-.5-.5v-86a.5.5,0,0,1,.5-.5H384.56a.5.5,0,0,1,.5.5v86A.5.5,0,0,1,384.56,326.9Zm-272-1H384.06v-85H112.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.69 161.97 112.81 240.42 384.56 240.42 248.69 161.97",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.56,240.92H112.81a.5.5,0,0,1-.25-.93l135.88-78.45a.5.5,0,0,1,.5,0L384.81,240a.49.49,0,0,1,.24.56A.5.5,0,0,1,384.56,240.92Zm-269.88-1h268l-134-77.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.11,
    y: 233.43,
    width: 67.43,
    height: 92.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.54,326.9H236.11a.5.5,0,0,1-.5-.5v-93a.5.5,0,0,1,.5-.5h67.43a.51.51,0,0,1,.5.5v93A.5.5,0,0,1,303.54,326.9Zm-66.93-1H303v-92H236.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.11,
    y: 233.43,
    width: 67.43,
    height: 3.95,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.54,237.89H236.11a.5.5,0,0,1-.5-.5v-4a.5.5,0,0,1,.5-.5h67.43a.51.51,0,0,1,.5.5v4A.51.51,0,0,1,303.54,237.89Zm-66.93-1H303v-3H236.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.66,326.4H253V268.29a16.83,16.83,0,0,1,16.83-16.84h0a16.84,16.84,0,0,1,16.84,16.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.66,326.9H253a.5.5,0,0,1-.5-.5V268.29a17.34,17.34,0,1,1,34.67,0V326.4A.5.5,0,0,1,286.66,326.9Zm-33.17-1h32.67V268.29a16.34,16.34,0,1,0-32.67,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.53,
    y: 255.48,
    width: 156.18,
    height: 70.92,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.71,326.9H92.53a.5.5,0,0,1-.5-.5V255.48a.5.5,0,0,1,.5-.5H248.71a.5.5,0,0,1,.5.5V326.4A.5.5,0,0,1,248.71,326.9ZM93,325.9H248.21V256H93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.53,
    y: 255.48,
    width: 156.18,
    height: 3.16,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.71,259.14H92.53a.5.5,0,0,1-.5-.5v-3.16a.5.5,0,0,1,.5-.5H248.71a.5.5,0,0,1,.5.5v3.16A.5.5,0,0,1,248.71,259.14ZM93,258.14H248.21V256H93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.71,
    y: 261.33,
    width: 121.81,
    height: 65.07,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.52,326.9H109.71a.5.5,0,0,1-.5-.5V261.33a.5.5,0,0,1,.5-.5H231.52a.5.5,0,0,1,.5.5V326.4A.5.5,0,0,1,231.52,326.9Zm-121.31-1H231V261.83H110.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.62 203.59 87.73 251.45 253.51 251.45 170.62 203.59",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.51,252H87.73a.5.5,0,0,1-.25-.93l82.89-47.86a.5.5,0,0,1,.5,0L253.76,251a.5.5,0,0,1-.25.93ZM89.6,251h162l-81-46.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.73,
    y: 251.45,
    width: 165.77,
    height: 4.03,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.51,256H87.73a.5.5,0,0,1-.5-.5v-4a.5.5,0,0,1,.5-.5H253.51a.5.5,0,0,1,.5.5v4A.5.5,0,0,1,253.51,256ZM88.23,255H253v-3H88.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.82 206.45 226.9 231.23 312.75 231.23 269.82 206.45",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.75,231.73H226.9a.5.5,0,0,1-.49-.37.49.49,0,0,1,.24-.56L269.57,206a.55.55,0,0,1,.5,0L313,230.8a.5.5,0,0,1-.25.93Zm-84-1h82.12L269.82,207Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.9,
    y: 231.23,
    width: 85.85,
    height: 3.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.75,235.71H226.9a.5.5,0,0,1-.5-.5v-4a.5.5,0,0,1,.5-.5h85.85a.5.5,0,0,1,.5.5v4A.5.5,0,0,1,312.75,235.71Zm-85.35-1h84.85v-3H227.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.15,
    y: 266.56,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,276.92h-9.86a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5H124a.5.5,0,0,1,.5.5v9.86A.5.5,0,0,1,124,276.92Zm-9.36-1h8.86v-8.86h-8.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.95,
    y: 266.56,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,276.92H129a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5h9.86a.5.5,0,0,1,.5.5v9.86A.5.5,0,0,1,138.81,276.92Zm-9.36-1h8.86v-8.86h-8.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.74,
    y: 266.56,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.61,276.92h-9.87a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5h9.87a.5.5,0,0,1,.5.5v9.86A.5.5,0,0,1,153.61,276.92Zm-9.37-1h8.87v-8.86h-8.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.54,
    y: 266.56,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.41,276.92h-9.87a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5h9.87a.5.5,0,0,1,.5.5v9.86A.5.5,0,0,1,168.41,276.92Zm-9.37-1h8.87v-8.86H159Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.34,
    y: 266.56,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.2,276.92h-9.86a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5h9.86a.5.5,0,0,1,.5.5v9.86A.5.5,0,0,1,183.2,276.92Zm-9.36-1h8.86v-8.86h-8.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.13,
    y: 266.56,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,276.92h-9.87a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5H198a.5.5,0,0,1,.5.5v9.86A.5.5,0,0,1,198,276.92Zm-9.37-1h8.87v-8.86h-8.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.93,
    y: 266.56,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.8,276.92h-9.87a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5h9.87a.5.5,0,0,1,.5.5v9.86A.5.5,0,0,1,212.8,276.92Zm-9.37-1h8.87v-8.86h-8.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.73,
    y: 266.56,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.59,276.92h-9.86a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5h9.86a.5.5,0,0,1,.5.5v9.86A.5.5,0,0,1,227.59,276.92Zm-9.36-1h8.86v-8.86h-8.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.15,
    y: 281.08,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,291.44h-9.86a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5H124a.5.5,0,0,1,.5.5v9.86A.5.5,0,0,1,124,291.44Zm-9.36-1h8.86v-8.86h-8.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.95,
    y: 281.08,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,291.44H129a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5h9.86a.5.5,0,0,1,.5.5v9.86A.5.5,0,0,1,138.81,291.44Zm-9.36-1h8.86v-8.86h-8.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.74,
    y: 281.08,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.61,291.44h-9.87a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5h9.87a.5.5,0,0,1,.5.5v9.86A.5.5,0,0,1,153.61,291.44Zm-9.37-1h8.87v-8.86h-8.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.54,
    y: 281.08,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.41,291.44h-9.87a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5h9.87a.5.5,0,0,1,.5.5v9.86A.5.5,0,0,1,168.41,291.44Zm-9.37-1h8.87v-8.86H159Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.34,
    y: 281.08,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.2,291.44h-9.86a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5h9.86a.5.5,0,0,1,.5.5v9.86A.5.5,0,0,1,183.2,291.44Zm-9.36-1h8.86v-8.86h-8.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.13,
    y: 281.08,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,291.44h-9.87a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5H198a.5.5,0,0,1,.5.5v9.86A.5.5,0,0,1,198,291.44Zm-9.37-1h8.87v-8.86h-8.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.93,
    y: 281.08,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.8,291.44h-9.87a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5h9.87a.5.5,0,0,1,.5.5v9.86A.5.5,0,0,1,212.8,291.44Zm-9.37-1h8.87v-8.86h-8.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.73,
    y: 281.08,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.59,291.44h-9.86a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5h9.86a.5.5,0,0,1,.5.5v9.86A.5.5,0,0,1,227.59,291.44Zm-9.36-1h8.86v-8.86h-8.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.15,
    y: 295.59,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,306h-9.86a.5.5,0,0,1-.5-.5v-9.87a.5.5,0,0,1,.5-.5H124a.5.5,0,0,1,.5.5v9.87A.5.5,0,0,1,124,306Zm-9.36-1h8.86v-8.87h-8.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.95,
    y: 295.59,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,306H129a.5.5,0,0,1-.5-.5v-9.87a.5.5,0,0,1,.5-.5h9.86a.5.5,0,0,1,.5.5v9.87A.5.5,0,0,1,138.81,306Zm-9.36-1h8.86v-8.87h-8.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.74,
    y: 295.59,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.61,306h-9.87a.51.51,0,0,1-.5-.5v-9.87a.5.5,0,0,1,.5-.5h9.87a.5.5,0,0,1,.5.5v9.87A.5.5,0,0,1,153.61,306Zm-9.37-1h8.87v-8.87h-8.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.54,
    y: 295.59,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.41,306h-9.87a.5.5,0,0,1-.5-.5v-9.87a.5.5,0,0,1,.5-.5h9.87a.5.5,0,0,1,.5.5v9.87A.51.51,0,0,1,168.41,306ZM159,305h8.87v-8.87H159Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.34,
    y: 295.59,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.2,306h-9.86a.5.5,0,0,1-.5-.5v-9.87a.5.5,0,0,1,.5-.5h9.86a.5.5,0,0,1,.5.5v9.87A.5.5,0,0,1,183.2,306Zm-9.36-1h8.86v-8.87h-8.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.13,
    y: 295.59,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,306h-9.87a.51.51,0,0,1-.5-.5v-9.87a.5.5,0,0,1,.5-.5H198a.5.5,0,0,1,.5.5v9.87A.5.5,0,0,1,198,306Zm-9.37-1h8.87v-8.87h-8.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.93,
    y: 295.59,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.8,306h-9.87a.51.51,0,0,1-.5-.5v-9.87a.5.5,0,0,1,.5-.5h9.87a.5.5,0,0,1,.5.5v9.87A.51.51,0,0,1,212.8,306Zm-9.37-1h8.87v-8.87h-8.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.73,
    y: 295.59,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.59,306h-9.86a.5.5,0,0,1-.5-.5v-9.87a.5.5,0,0,1,.5-.5h9.86a.5.5,0,0,1,.5.5v9.87A.5.5,0,0,1,227.59,306Zm-9.36-1h8.86v-8.87h-8.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.15,
    y: 310.11,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,320.47h-9.86a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5H124a.5.5,0,0,1,.5.5V320A.5.5,0,0,1,124,320.47Zm-9.36-1h8.86v-8.86h-8.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.95,
    y: 310.11,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,320.47H129a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5h9.86a.5.5,0,0,1,.5.5V320A.5.5,0,0,1,138.81,320.47Zm-9.36-1h8.86v-8.86h-8.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.74,
    y: 310.11,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.61,320.47h-9.87a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5h9.87a.5.5,0,0,1,.5.5V320A.5.5,0,0,1,153.61,320.47Zm-9.37-1h8.87v-8.86h-8.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.54,
    y: 310.11,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.41,320.47h-9.87a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5h9.87a.5.5,0,0,1,.5.5V320A.5.5,0,0,1,168.41,320.47Zm-9.37-1h8.87v-8.86H159Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.34,
    y: 310.11,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.2,320.47h-9.86a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5h9.86a.5.5,0,0,1,.5.5V320A.5.5,0,0,1,183.2,320.47Zm-9.36-1h8.86v-8.86h-8.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.13,
    y: 310.11,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,320.47h-9.87a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5H198a.5.5,0,0,1,.5.5V320A.5.5,0,0,1,198,320.47Zm-9.37-1h8.87v-8.86h-8.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.93,
    y: 310.11,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.8,320.47h-9.87a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5h9.87a.5.5,0,0,1,.5.5V320A.5.5,0,0,1,212.8,320.47Zm-9.37-1h8.87v-8.86h-8.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.73,
    y: 310.11,
    width: 9.86,
    height: 9.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.59,320.47h-9.86a.5.5,0,0,1-.5-.5v-9.86a.5.5,0,0,1,.5-.5h9.86a.5.5,0,0,1,.5.5V320A.5.5,0,0,1,227.59,320.47Zm-9.36-1h8.86v-8.86h-8.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.78,326.9a.5.5,0,0,1-.5-.5V316.08a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V326.4A.5.5,0,0,1,259.78,326.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "277.91 326.4 277.91 271.49 259.78 271.49 259.78 311.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.91,326.9a.5.5,0,0,1-.5-.5V272H260.28v39.54a.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5v-40a.51.51,0,0,1,.5-.5h18.13a.51.51,0,0,1,.5.5V326.4A.5.5,0,0,1,277.91,326.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.29 326.4 292.67 326.4 292.67 233.43 342.48 206.45 392.29 233.43 392.29 326.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.29,326.9H292.67a.5.5,0,0,1-.5-.5v-93a.51.51,0,0,1,.26-.44l49.81-27a.51.51,0,0,1,.48,0l49.81,27a.51.51,0,0,1,.26.44v93A.5.5,0,0,1,392.29,326.9Zm-99.12-1h98.62V233.73L342.48,207l-49.31,26.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.9 237.39 342.48 206.28 285.06 237.39 283.27 234.09 342.48 202.01 401.69 234.09 399.9 237.39",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.9,237.89a.46.46,0,0,1-.23-.06l-57.19-31-57.19,31a.55.55,0,0,1-.38,0,.51.51,0,0,1-.29-.25l-1.79-3.29a.5.5,0,0,1,.2-.68l59.21-32.08a.51.51,0,0,1,.48,0l59.21,32.08a.52.52,0,0,1,.24.3.51.51,0,0,1,0,.38l-1.79,3.29A.5.5,0,0,1,399.9,237.89Zm-57.42-32.11a.53.53,0,0,1,.24.06l57,30.87,1.31-2.42-58.53-31.71L284,234.29l1.31,2.42,57-30.87A.53.53,0,0,1,342.48,205.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.67 233.43 292.67 235.69 342.48 208.71 392.29 235.69 392.29 233.43 342.48 206.45 292.67 233.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.29,236.19a.53.53,0,0,1-.24-.06l-49.57-26.85-49.57,26.85a.48.48,0,0,1-.49,0,.48.48,0,0,1-.25-.43v-2.26a.51.51,0,0,1,.26-.44l49.81-27a.51.51,0,0,1,.48,0l49.81,27a.51.51,0,0,1,.26.44v2.26a.5.5,0,0,1-.24.43A.48.48,0,0,1,392.29,236.19Zm-49.81-28a.53.53,0,0,1,.24.06l49.07,26.58v-1.12L342.48,207l-49.31,26.71v1.12l49.07-26.58A.53.53,0,0,1,342.48,208.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "320.69 256.01 320.69 246.21 363.67 246.21 363.67 295.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.67,295.56a.5.5,0,0,1-.5-.5V246.71h-42V256a.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5v-9.8a.5.5,0,0,1,.5-.5h43a.5.5,0,0,1,.5.5v48.85A.5.5,0,0,1,363.67,295.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "363.67 300.11 363.67 309.73 320.69 309.73 320.69 259.74",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.67,310.23h-43a.5.5,0,0,1-.5-.5v-50a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v49.49h42v-9.12a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v9.62A.51.51,0,0,1,363.67,310.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.09,
    y: 265.3,
    width: 16.72,
    height: 11.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.8,277.42H344.09a.5.5,0,0,1-.5-.5V265.3a.5.5,0,0,1,.5-.5H360.8a.5.5,0,0,1,.5.5v11.62A.5.5,0,0,1,360.8,277.42Zm-16.21-1H360.3V265.8H344.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.09,
    y: 280.74,
    width: 16.72,
    height: 11.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.8,292.85H344.09a.5.5,0,0,1-.5-.5V280.74a.5.5,0,0,1,.5-.5H360.8a.5.5,0,0,1,.5.5v11.61A.5.5,0,0,1,360.8,292.85Zm-16.21-1H360.3V281.24H344.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.09,
    y: 249.07,
    width: 16.72,
    height: 12.4,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.8,262H344.09a.5.5,0,0,1-.5-.5V249.07a.5.5,0,0,1,.5-.5H360.8a.5.5,0,0,1,.5.5v12.41A.5.5,0,0,1,360.8,262Zm-16.21-1H360.3V249.57H344.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.55,
    y: 249.07,
    width: 16.72,
    height: 12.4,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.27,262H323.55a.5.5,0,0,1-.5-.5V249.07a.5.5,0,0,1,.5-.5h16.72a.51.51,0,0,1,.5.5v12.41A.51.51,0,0,1,340.27,262Zm-16.22-1h15.72V249.57H324.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.55,
    y: 280.74,
    width: 16.72,
    height: 11.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.27,292.85H323.55a.5.5,0,0,1-.5-.5V280.74a.5.5,0,0,1,.5-.5h16.72a.5.5,0,0,1,.5.5v11.61A.5.5,0,0,1,340.27,292.85Zm-16.22-1h15.72V281.24H324.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.55,
    y: 265.3,
    width: 16.72,
    height: 11.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.27,277.42H323.55a.5.5,0,0,1-.5-.5V265.3a.5.5,0,0,1,.5-.5h16.72a.5.5,0,0,1,.5.5v11.62A.51.51,0,0,1,340.27,277.42Zm-16.22-1h15.72V265.8H324.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.09,
    y: 296.17,
    width: 16.72,
    height: 10.69,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.8,307.36H344.09a.5.5,0,0,1-.5-.5V296.17a.5.5,0,0,1,.5-.5H360.8a.5.5,0,0,1,.5.5v10.69A.5.5,0,0,1,360.8,307.36Zm-16.21-1H360.3v-9.69H344.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.55,
    y: 296.17,
    width: 16.72,
    height: 10.69,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.27,307.36H323.55a.5.5,0,0,1-.5-.5V296.17a.5.5,0,0,1,.5-.5h16.72a.51.51,0,0,1,.5.5v10.69A.5.5,0,0,1,340.27,307.36Zm-16.22-1h15.72v-9.69H324.05Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.17,365.25h-2a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,342.17,365.25Zm-6,0h-2a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,336.17,365.25Zm-6,0h-2a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,330.17,365.25Zm-6,0h-2a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,324.17,365.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.21,365.25c-.3,0-.59,0-.89,0a.5.5,0,0,1-.47-.53.49.49,0,0,1,.53-.47c.29,0,.58,0,.88,0h1.09a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-1.14Zm187.14,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,304.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,298.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,292.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,286.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,280.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,274.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,268.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,262.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,256.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,250.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,244.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,238.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,232.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,226.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,220.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,214.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,208.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,202.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,196.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,190.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,184.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,178.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,172.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,166.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,160.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,154.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,148.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,142.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,136.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,130.35,365.25Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,124.35,365.25Zm-11.92-.77a.39.39,0,0,1-.15,0,16.65,16.65,0,0,1-1.92-.76.51.51,0,0,1-.24-.67.5.5,0,0,1,.67-.24,14.68,14.68,0,0,0,1.8.72.5.5,0,0,1-.16,1Zm-5.2-2.9a.52.52,0,0,1-.33-.12,16.55,16.55,0,0,1-1.48-1.42.5.5,0,1,1,.73-.68,17.72,17.72,0,0,0,1.4,1.34.51.51,0,0,1,.06.71A.52.52,0,0,1,107.23,361.58Zm-3.74-4.64a.51.51,0,0,1-.45-.27,15.83,15.83,0,0,1-.84-1.88.5.5,0,0,1,.29-.64.5.5,0,0,1,.65.29,14.7,14.7,0,0,0,.79,1.77.5.5,0,0,1-.44.73Zm-1.72-5.71a.51.51,0,0,1-.5-.45c0-.53-.08-1.06-.08-1.6v-.45a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v.45a14.91,14.91,0,0,0,.08,1.5.51.51,0,0,1-.45.55Zm-.08-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,345.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,339.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,333.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,327.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,321.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,315.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,309.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,303.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,297.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,291.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,285.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,279.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,273.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,267.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,261.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,255.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,249.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,243.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,237.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,231.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,225.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,219.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,213.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,207.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,201.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,195.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,189.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,183.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,177.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,171.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,165.23Zm0-6a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,101.69,159.23Zm0-6h0a.5.5,0,0,1-.47-.53,17.41,17.41,0,0,1,.27-2,.5.5,0,0,1,1,.2,15.36,15.36,0,0,0-.25,1.91A.5.5,0,0,1,101.73,153.23Zm1.53-5.76a.44.44,0,0,1-.22-.05.5.5,0,0,1-.23-.67,15.86,15.86,0,0,1,1-1.79.5.5,0,0,1,.84.55,14,14,0,0,0-1,1.68A.5.5,0,0,1,103.26,147.47Zm3.59-4.76a.47.47,0,0,1-.37-.16.5.5,0,0,1,0-.71,16.55,16.55,0,0,1,1.62-1.28.5.5,0,1,1,.57.82,16,16,0,0,0-1.52,1.2A.46.46,0,0,1,106.85,142.71Zm5.11-3.07a.49.49,0,0,1-.47-.33.5.5,0,0,1,.3-.64,17.19,17.19,0,0,1,2-.57.5.5,0,0,1,.6.38.49.49,0,0,1-.38.59,15.19,15.19,0,0,0-1.86.54A.51.51,0,0,1,112,139.64Zm7.89-.92h-2a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,119.85,138.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.24,154.28a.5.5,0,0,1-.5-.5,15.63,15.63,0,0,0-.12-1.93.5.5,0,0,1,.43-.56.52.52,0,0,1,.56.43,17.66,17.66,0,0,1,.13,2.06A.5.5,0,0,1,379.24,154.28Zm-1.14-5.85a.49.49,0,0,1-.46-.31,14.75,14.75,0,0,0-.85-1.74.52.52,0,0,1,.19-.69.5.5,0,0,1,.68.19,15.93,15.93,0,0,1,.9,1.86.49.49,0,0,1-.27.65A.43.43,0,0,1,378.1,148.43Zm-3.26-5a.48.48,0,0,1-.36-.16A14.72,14.72,0,0,0,373,142a.51.51,0,0,1,.63-.79,16.82,16.82,0,0,1,1.53,1.39.51.51,0,0,1-.36.85Zm-4.9-3.41a.51.51,0,0,1-.2,0,13.94,13.94,0,0,0-1.81-.66.5.5,0,0,1-.34-.63.5.5,0,0,1,.62-.33,16.61,16.61,0,0,1,1.94.7.51.51,0,0,1,.25.66A.49.49,0,0,1,369.94,140Zm-5.81-1.31h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.49.52A.5.5,0,0,1,364.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,358.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,352.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,346.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,340.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,334.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,328.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,322.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,316.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,310.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,304.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,298.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,292.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,286.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,280.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,274.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,268.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,262.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,256.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,250.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,244.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,238.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,232.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,226.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,220.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,214.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,208.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,202.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,196.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,190.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,184.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,178.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,172.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,166.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,160.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,154.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,148.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,142.13,138.72Zm-6,0h-2a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5A.5.5,0,0,1,136.13,138.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.83,161.26A64.13,64.13,0,1,0,443.32,225,64.13,64.13,0,0,0,378.83,161.26Zm.65,115.6a51.47,51.47,0,1,1,51.18-51.76A51.47,51.47,0,0,1,379.48,276.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.18,290a64.63,64.63,0,0,1-.35-129.26v0h.37A64.63,64.63,0,0,1,379.55,290Zm0-128.26h-.37A63.63,63.63,0,0,0,379.18,289h.37a63.63,63.63,0,0,0-.35-127.26Zm0,115.6a52,52,0,0,1-.29-103.93h.29a52,52,0,0,1,.29,103.93Zm.29-1v0a51,51,0,0,0-.29-101.93h-.29a51,51,0,0,0,.29,101.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.81,157.59a64.13,64.13,0,1,0,64.49,63.76A64.13,64.13,0,0,0,378.81,157.59Zm.65,115.59a51.47,51.47,0,1,1,51.17-51.75A51.47,51.47,0,0,1,379.46,273.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.16,286.34a64.46,64.46,0,1,1,.37,0Zm0-128.25h-.37a63.63,63.63,0,0,0,.35,127.25h.37a63.63,63.63,0,0,0-.35-127.25Zm0,115.59a52,52,0,0,1-.28-103.93h.3a52,52,0,0,1,.28,103.93h-.3Zm0-102.93h-.3a51,51,0,0,0,.28,101.93h.3a51,51,0,0,0-.28-101.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.36,
    y: 287.27,
    width: 15.52,
    height: 57.18,
    rx: 2.88,
    transform: "matrix(1, -0.01, 0.01, 1, -1.76, 2.13)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.38,345a3.4,3.4,0,0,1-3.38-3.37l-.29-51.41a3.41,3.41,0,0,1,1-2.4,3.35,3.35,0,0,1,2.39-1l9.75-.06a3.51,3.51,0,0,1,2.4,1,3.35,3.35,0,0,1,1,2.39l.29,51.41a3.4,3.4,0,0,1-3.36,3.41h0l-9.75.05Zm9.78-.55h0Zm-.31-56.69h0l-9.76.06a2.37,2.37,0,0,0-1.68.7,2.4,2.4,0,0,0-.69,1.69l.29,51.42a2.4,2.4,0,0,0,.71,1.68,2.34,2.34,0,0,0,1.67.69h0l9.75-.05a2.39,2.39,0,0,0,2.37-2.4l-.29-51.42a2.37,2.37,0,0,0-.7-1.68A2.4,2.4,0,0,0,384.85,287.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.49,413.76l-13.11.08a7.31,7.31,0,0,1-7.35-7.27l0-76.75a5.71,5.71,0,0,1,5.68-5.74L388,324a5.7,5.7,0,0,1,5.74,5.68l0,76.75A7.3,7.3,0,0,1,386.49,413.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.34,414.33a7.81,7.81,0,0,1-7.81-7.76l0-76.75a6.21,6.21,0,0,1,6.17-6.24l16.31-.09h0a6.2,6.2,0,0,1,6.21,6.17l0,76.76a7.8,7.8,0,0,1-7.76,7.84h0l-13.11.07Zm13.15-.57h0ZM388,324.49h0l-16.3.09a5.21,5.21,0,0,0-5.18,5.24l0,76.75a6.81,6.81,0,0,0,6.81,6.76h0l13.11-.07a6.8,6.8,0,0,0,6.77-6.84l0-76.75A5.21,5.21,0,0,0,388,324.49Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseSearchingBro);
export default __webpack_public_path__ + "static/media/House-searching-bro.a7b3da8a7b692746db83f81f0d209391.svg";
export { ForwardRef as ReactComponent };